










































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import PpiKepatuhanTrenCard from "@/components/ppi/rekap/PpiKepatuhanTrenCard.vue";
import { PPI_CAKUPAN_ITEMS, ppiCakupanPicker } from "@/utils/unit";
import {
  PpiRekapCakupan,
  PpiTrenMode,
  PpiUnitScope
} from "@/services/PpiBundleRekapBulananService";
import PpiRekapKepatuhanService, {
  PpiKepatuhanKelompok,
  PpiKepatuhanMatriks,
  PpiKepatuhanMode,
  PpiKepatuhanPerBangsal,
  PpiKepatuhanRuangan,
  PpiKepatuhanTren
} from "@/services/PpiRekapKepatuhanService";

@Component({
  components: { UnitRuangPicker, PpiKepatuhanTrenCard }
})
export default class PpiRekapKepatuhan extends Vue {
  @Prop({ required: true }) readonly kelompok!: PpiKepatuhanKelompok;

  loading = false;
  loadingBangsal = false;

  tab = 0;
  mode: PpiKepatuhanMode = "bulanan";
  periode = "";
  unitId: string | null = null;
  cakupan: PpiRekapCakupan = "ranap";
  hanyaAdaData = true;

  modeItems = [
    { text: "Bulanan", value: "bulanan" },
    { text: "Triwulan", value: "triwulan" },
    { text: "Semester", value: "semester" },
    { text: "Tahunan", value: "tahunan" }
  ];

  triwulanItems = [
    { text: "I (Jan – Mar)", value: 1 },
    { text: "II (Apr – Jun)", value: 2 },
    { text: "III (Jul – Sep)", value: 3 },
    { text: "IV (Okt – Des)", value: 4 }
  ];

  semesterItems = [
    { text: "I (Jan – Jun)", value: 1 },
    { text: "II (Jul – Des)", value: 2 }
  ];

  cakupanItems = PPI_CAKUPAN_ITEMS;

  matriks: PpiKepatuhanMatriks | null = null;
  bangsal: PpiKepatuhanPerBangsal | null = null;

  trenMode: PpiTrenMode = "bulanan";
  trenSemua: PpiKepatuhanTren | null = null;
  trenBangsal: PpiKepatuhanTren | null = null;
  loadingTrenSemua = false;
  loadingTrenBangsal = false;
  trenSemuaSeq = 0;
  trenBangsalSeq = 0;
  bangsalSeq = 0;

  unitScope: PpiUnitScope = {
    is_kepala_ruang: false,
    unit_id: null,
    unit_nama: null
  };

  created() {
    this.cakupan = this.kelompok === "audit" ? "semua" : "ranap";
  }

  async mounted() {
    this.periode = this.periodeDefault();
    await this.loadData();
  }

  @Watch("mode")
  onModeChange() {
    this.periode = this.periodeDefault();
    this.matriks = null;
    this.bangsal = null;
    this.trenSemua = null;
    this.trenBangsal = null;
    this.trenMode = this.mode;
  }

  @Watch("cakupan")
  onCakupanChange() {
    this.matriks = null;
    this.bangsal = null;
    this.trenBangsal = null;
    this.loadData();
  }

  @Watch("trenMode")
  onTrenModeChange() {
    if (this.matriks && !this.isKepalaRuang) this.loadTrenSemua();
    if (this.bangsal) this.loadTrenBangsal();
  }

  get judul(): string {
    return this.kelompok === "audit"
      ? "Rekap Audit PPI"
      : "Rekap Surveilans PPI";
  }

  get judulMatriks(): string {
    return this.kelompok === "audit"
      ? "Kepatuhan Audit PPI per Ruangan"
      : "Kepatuhan Surveilans Hand Hygiene & APD per Ruangan";
  }

  get ikon(): string {
    return this.kelompok === "audit"
      ? "mdi-clipboard-check-multiple-outline"
      : "mdi-clipboard-pulse";
  }

  get deskripsi(): string {
    return this.kelompok === "audit"
      ? "Rekap 10 jenis audit PPI & Kesling per ruangan. Num = item dijawab Ya/Patuh, Den = item yang dinilai (N/A tidak dihitung)."
      : "Rekap Surveilans Hand Hygiene & APD per ruangan. HH: Num = handrub + handwash, Den = jumlah indikasi. APD: Num = petugas patuh, Den = petugas yang diobservasi.";
  }

  get isKepalaRuang(): boolean {
    return this.unitScope.is_kepala_ruang;
  }

  get isTabPerBangsal(): boolean {
    return this.isKepalaRuang || this.tab === 1;
  }

  get pickerCfg() {
    return ppiCakupanPicker(this.isKepalaRuang ? "semua" : this.cakupan);
  }

  get ruanganTampil(): PpiKepatuhanRuangan[] {
    if (!this.matriks) return [];
    return this.hanyaAdaData
      ? this.matriks.ruangan.filter(r => r.ada_data)
      : this.matriks.ruangan;
  }

  get isRentangBulan(): boolean {
    return this.mode === "triwulan" || this.mode === "semester";
  }

  get modeLabelJudul(): string {
    const item = this.modeItems.find(m => m.value === this.mode);
    return item ? item.text : this.mode;
  }

  get kodeRentang(): string {
    return this.mode === "triwulan" ? "Q" : "S";
  }

  get periodeTahun(): string {
    return this.periode.slice(0, 4);
  }

  get periodeKe(): number {
    return Number(this.periode.slice(6)) || 1;
  }

  get periodeKeItems() {
    return this.mode === "triwulan" ? this.triwulanItems : this.semesterItems;
  }

  get tahunItems(): string[] {
    const kini = new Date().getFullYear();
    const tahun: string[] = [];
    for (let i = 0; i < 6; i++) tahun.push(String(kini - i));
    return tahun;
  }

  setPeriodeTahun(tahun: string) {
    this.periode = `${tahun}-${this.kodeRentang}${this.periodeKe}`;
  }

  setPeriodeKe(ke: number) {
    this.periode = `${this.periodeTahun}-${this.kodeRentang}${ke}`;
  }

  periodeDefault(): string {
    const now = new Date();
    const pad = (n: number) => String(n).padStart(2, "0");

    if (this.mode === "tahunan") {
      return String(now.getFullYear());
    }

    const prev = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    if (this.isRentangBulan) {
      const bulanPerRentang = this.mode === "triwulan" ? 3 : 6;
      const ke = Math.floor(prev.getMonth() / bulanPerRentang) + 1;
      return `${prev.getFullYear()}-${this.kodeRentang}${ke}`;
    }
    return `${prev.getFullYear()}-${pad(prev.getMonth() + 1)}`;
  }

  async loadData() {
    if (!this.periode) return;
    this.loading = true;
    try {
      const resp = await PpiRekapKepatuhanService.matriks(
        this.kelompok,
        this.mode,
        this.periode,
        this.cakupan
      );
      const data: PpiKepatuhanMatriks | null = resp.data?.data || null;
      this.matriks = data;

      if (data?.unit_scope) {
        this.unitScope = data.unit_scope;
        if (this.unitScope.is_kepala_ruang && this.unitScope.unit_id) {
          this.unitId = this.unitScope.unit_id;
          this.loadPerBangsal();
        }
      }
      if (!this.isKepalaRuang) this.loadTrenSemua();
    } catch (e) {
      this.matriks = null;
    } finally {
      this.loading = false;
    }
  }

  async loadPerBangsal() {
    if (!this.periode || !this.unitId) return;
    const seq = ++this.bangsalSeq;
    this.loadingBangsal = true;
    this.loadTrenBangsal();
    try {
      const resp = await PpiRekapKepatuhanService.perBangsal(
        this.kelompok,
        this.mode,
        this.periode,
        this.unitId
      );
      if (seq === this.bangsalSeq) this.bangsal = resp.data?.data || null;
    } catch (e) {
      if (seq === this.bangsalSeq) this.bangsal = null;
    } finally {
      if (seq === this.bangsalSeq) this.loadingBangsal = false;
    }
  }

  async loadTrenSemua() {
    if (!this.periode) return;
    const seq = ++this.trenSemuaSeq;
    this.loadingTrenSemua = true;
    try {
      const resp = await PpiRekapKepatuhanService.tren(
        this.kelompok,
        this.trenMode,
        this.periode.slice(0, 4),
        this.cakupan
      );
      if (seq === this.trenSemuaSeq) this.trenSemua = resp.data?.data || null;
    } catch (e) {
      if (seq === this.trenSemuaSeq) this.trenSemua = null;
    } finally {
      if (seq === this.trenSemuaSeq) this.loadingTrenSemua = false;
    }
  }

  async loadTrenBangsal() {
    if (!this.periode || !this.unitId) return;
    const seq = ++this.trenBangsalSeq;
    this.loadingTrenBangsal = true;
    try {
      const resp = await PpiRekapKepatuhanService.tren(
        this.kelompok,
        this.trenMode,
        this.periode.slice(0, 4),
        this.cakupan,
        this.unitId
      );
      if (seq === this.trenBangsalSeq)
        this.trenBangsal = resp.data?.data || null;
    } catch (e) {
      if (seq === this.trenBangsalSeq) this.trenBangsal = null;
    } finally {
      if (seq === this.trenBangsalSeq) this.loadingTrenBangsal = false;
    }
  }

  fmt(val: number | null): string {
    if (val === null || val === undefined) return "—";
    return val.toFixed(2).replace(".", ",");
  }

  fmtTarget(val: number): string {
    return String(val).replace(".", ",");
  }

  kategoriClass(kategori: string): string {
    if (kategori === "baik") return "kat-baik";
    if (kategori === "cukup") return "kat-cukup";
    if (kategori === "kurang") return "kat-kurang";
    return "";
  }
}
